(() => {
  const initPolicyPage = () => {
    const page = document.querySelector('[data-policy-page]');
    if (!page) return;

    const source = page.querySelector('[data-policy-source]');
    const content = source && source.querySelector('.shopify-policy__body .rte');
    if (!content) return;

    const normalize = (value) => value.replace(/\s+/g, ' ').trim();
    const slugify = (value) => normalize(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const dateParagraph = Array.from(content.querySelectorAll('p')).find((paragraph) =>
      /^last updated\s*:/i.test(normalize(paragraph.textContent || ''))
    );
    if (dateParagraph) {
      const updated = page.querySelector('[data-policy-updated]');
      updated.textContent = normalize(dateParagraph.textContent || '');
      updated.hidden = false;
      dateParagraph.remove();
    }

    const sectionCopy = new Map();
    Array.from(content.querySelectorAll('p')).forEach((paragraph) => {
      const firstBreak = paragraph.querySelector('br');
      if (!firstBreak) return;

      const nodes = Array.from(paragraph.childNodes);
      const breakIndex = nodes.indexOf(firstBreak);
      const headingText = normalize(nodes.slice(0, breakIndex).map((node) => node.textContent || '').join(' '));
      if (!headingText || breakIndex < 0) return;

      const bodyNodes = nodes.slice(breakIndex + 1);
      const bodyText = normalize(bodyNodes.map((node) => node.textContent || '').join(' '));
      if (!bodyText) return;

      sectionCopy.set(headingText.toLowerCase(), bodyText);
      const heading = document.createElement('h2');
      heading.textContent = headingText;
      const body = document.createElement('p');
      bodyNodes.forEach((node) => body.appendChild(node));
      paragraph.replaceWith(heading, body);
    });

    const headings = Array.from(content.querySelectorAll('h2'));
    const usedIds = new Set();
    headings.forEach((heading, index) => {
      let baseId = heading.id || slugify(heading.textContent || '') || `section-${index + 1}`;
      let id = baseId;
      let suffix = 2;
      while (usedIds.has(id)) id = `${baseId}-${suffix++}`;
      heading.id = id;
      usedIds.add(id);
    });

    let activeLockUntil = 0;
    const setActive = (id) => {
      page.querySelectorAll('.parkero-policy__toc a').forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
      });
    };

    const buildToc = (container) => {
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = normalize(heading.textContent || '');
        if (index === 0) link.classList.add('is-active');
        link.addEventListener('click', () => {
          activeLockUntil = Date.now() + 1200;
          setActive(heading.id);
          page.querySelectorAll('[data-policy-mobile-toc]').forEach((toc) => {
            const details = toc.closest('details');
            if (details) details.open = false;
          });
        });
        fragment.appendChild(link);
      });
      container.appendChild(fragment);
    };

    page.querySelectorAll('[data-policy-toc], [data-policy-mobile-toc]').forEach(buildToc);

    if ('IntersectionObserver' in window && headings.length) {
      const observer = new IntersectionObserver((entries) => {
        if (Date.now() < activeLockUntil) return;
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      }, { rootMargin: '-20% 0px -68% 0px', threshold: 0 });
      headings.forEach((heading) => observer.observe(heading));
    }

    if (page.dataset.policyKind === 'shipping') {
      const sectionText = (label) => {
        const stored = sectionCopy.get(label.toLowerCase());
        if (stored) return stored;
        const heading = headings.find((item) => normalize(item.textContent || '').toLowerCase() === label.toLowerCase());
        return normalize((heading && heading.nextElementSibling && heading.nextElementSibling.textContent) || '');
      };
      const sentence = (value) => (value.match(/^[^.!?]+[.!?]?/) || [''])[0].trim();
      const range = (value, includeProcessing) => {
        const match = value.match(/\b\d+\s*[-–]\s*\d+\s+business days(?:\s+after processing)?/i);
        if (!match) return sentence(value);
        const result = normalize(match[0]).replace(/\s*[-–]\s*/, '–');
        return includeProcessing ? result : result.replace(/\s+after processing$/i, '');
      };

      const shipping = sectionText('Shipping Method');
      const processing = sectionText('Processing Time');
      const delivery = sectionText('Estimated Delivery');
      const tracking = sectionText('Order Tracking');
      const cards = [
        shipping && {
          label: /^free standard shipping/i.test(shipping) ? 'Free Standard Shipping' : 'Shipping Method',
          value: /eligible orders.*united states/i.test(shipping) ? 'Eligible U.S. orders' : sentence(shipping)
        },
        processing && { label: 'Processing Time', value: range(processing, false) },
        delivery && { label: 'Estimated Delivery', value: range(delivery, true) },
        tracking && {
          label: 'Order Tracking',
          value: /provided by email when available/i.test(tracking) ? 'Provided by email when available' : sentence(tracking)
        }
      ].filter(Boolean);

      if (cards.length === 4) {
        const cardContainer = page.querySelector('[data-shipping-cards]');
        cards.forEach((card) => {
          const item = document.createElement('div');
          item.className = 'parkero-policy__glance-card';
          const label = document.createElement('strong');
          label.textContent = card.label;
          const value = document.createElement('span');
          value.textContent = card.value;
          item.append(label, value);
          cardContainer.appendChild(item);
        });
        page.querySelector('[data-shipping-glance]').hidden = false;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyPage, { once: true });
  } else {
    initPolicyPage();
  }
})();
